import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export abstract class AmazonRegisterFormBaseComponent {
  activationForm: FormGroup;
  isSubmitted = false;
  isSubmitting = false;

  constructor(protected fb: FormBuilder) {
    this.activationForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  hasError(controlName: string): boolean {
    const control = this.activationForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || this.isSubmitted));
  }

  abstract onSubmit(event?: Event): void;

  abstract onDblClick(event?: Event): void;
}
